import moment from 'moment-timezone';
import { i18nMark } from 'lingui-react';

const DAYS_HOURS_MINUTES = i18nMark('{days} d {hours} hr {minutes} min');
const HOURS_MINUTES = i18nMark('{hours} hr {minutes} min');
const MINUTES = i18nMark('{minutes} min');
const SECONDS = i18nMark('{seconds} sec');

function selectTemplate(duration) {
  if (duration.get('days') >= 1) {
    return DAYS_HOURS_MINUTES;
  }

  if (duration.get('hours') >= 1) {
    return HOURS_MINUTES;
  }

  if (duration.get('minutes') >= 1) {
    return MINUTES;
  }

  return SECONDS;
}

const SUBSTITUTION_UNITS = ['days', 'hours', 'minutes', 'seconds'];
const SUBSTITUTION_REGEXP = `{(${SUBSTITUTION_UNITS.join('|')})}`;

export function formattedDuration(i18n, duration) {
  const template = selectTemplate(duration);
  const values = {
    days: Math.floor(duration.asDays()),
    hours: duration.get('hours'),
    minutes: duration.get('minutes'),
    seconds: duration.get('seconds'),
  };

  if (i18n) {
    return i18n._(template, { values });
  }

  const regExp = new RegExp(SUBSTITUTION_REGEXP, 'g');
  return template.replace(regExp, matched => values[matched.slice(1, -1)]);
}

export default function countOfTime(duration, { i18n } = {}) {
  return formattedDuration(i18n, moment.duration(duration));
}



// WEBPACK FOOTER //
// ./src/utils/countOfTime.js